<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import { GravyPath } from "@/path";
import Add from "@/views/pages/Dilfoods/Gravy/Orders/add.vue";
import AccpetOrders from "@/views/pages/Dilfoods/Gravy/Orders/accpetOrders";
import MarkAsShipped from "@/views/pages/Dilfoods/Gravy/Orders/markAsShipped";
import MarkAsDelivered from "@/views/pages/Dilfoods/Gravy/Orders/markAsDelivered";
import Swal from "sweetalert2";
import View_items from "@/views/pages/Dilfoods/Gravy/Orders/view_items";
import moment from "moment";
import Payments from "./payments.vue";
import Refund from "./refund.vue";
import EditIcon from "@/views/pages/Dilfoods/Common/icons/EditIcon.vue";
import DeleteIcon from "@/views/pages/Dilfoods/Common/icons/DeleteIcon.vue";
import DeliveredIcon from "@/views/pages/Dilfoods/Common/icons/DeliveredIcon.vue";
import ShippedIcon from "@/views/pages/Dilfoods/Common/icons/ShippedIcon.vue";
import DownloadIcon from "@/views/pages/Dilfoods/Common/icons/DownloadIcon.vue";
import PendingIcon from "@/views/pages/Dilfoods/Common/icons/PendingIcon.vue";
import CardIcon from "@/views/pages/Dilfoods/Common/icons/CardIcon.vue";
import ListIcon from "@/views/pages/Dilfoods/Common/icons/ListIcon.vue";
import RegenerateIcon from "@/views/pages/Dilfoods/Common/icons/RegenerateIcon.vue";
import AcceptIcon from "@/views/pages/Dilfoods/Common/icons/AcceptIcon.vue";
import BrandKit from "./brandKit.vue";
import EditBrandKit from "./editBrandKit.vue";
import View_returns from "./OrderReturns/add.vue";

/* Dashboard component */
export default {
  components: {
    View_items,
    View_returns,
    MarkAsShipped,
    MarkAsDelivered,
    AccpetOrders,
    Add,
    BrandKit,
    EditBrandKit,
    Layout,
    PageHeader,    Payments,
    Refund,
    EditIcon,
    DeleteIcon,
    DeliveredIcon,
    DownloadIcon,
    PendingIcon,
    CardIcon,
    ListIcon,
    RegenerateIcon,
    ShippedIcon,
    AcceptIcon,
  },
  data() {
    return {
      title: "Gravy Orders",
      items: [
        {
          text: "List",
        },
        {
          text: "gravy orders",
          active: true,
        },
      ],
      orders: [],
      selectedOrder: {},
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      cdn: process.env.VUE_APP_AWS_CDN,
      filter: [],
      currentPage: 1,
      order_type: "pending",
      search: "",
      lpgOnly: false,
      horecaOnly: false,
      fields: [
        "ref_id",
        "restaurant",
        "city",
        "view_items",
        "expected_delivery_date",
        "created_by",
        "created_at",
        "order_status",
        { key: "cw", label: "CW" },
        "shipped_at",
        "delivered_at",
        "Payment",
        "invoice",
        "actions",
      ],
    };
  },
  watch: {
    currentPage() {
      this.getOrders();
    },
    order_type() {
      this.getOrders();
    },
    search() {
      this.getOrders();
    },
    lpgOnly() {
      this.currentPage = 1;
      this.getOrders();
    },
    horecaOnly() {
      this.currentPage = 1;
      this.getOrders();
    },
  },
  computed: {
    // SuperAdmin keeps an escape hatch on paid HORECA orders. Every other role is
    // blocked — including SubAdmin, which is what Order Management runs as.
    isSuperAdmin() {
      return this.$store.state.authfack.user.roles.some(
        (f) => f.name == "SuperAdmin"
      );
    },
    // Must match the role middleware on gravy_publish_to_cw.
    canPublishToCw() {
      return this.isSuperAdmin;
    },
  },
  methods: {
    async getOrders() {
      try {
        let response = await axios.get(this.base_url + GravyPath.ORDERS.GET, {
          params: {
            page: this.currentPage,
            order_type: this.order_type,
            search: this.search,
            lpg_only: this.lpgOnly ? 1 : undefined,
            horeca_only: this.horecaOnly ? 1 : undefined,
          },
        });
        if (response.data.status == true) {
          this.orders = response.data.data;
          console.log(this.orders, "orders");
        }
      } catch (e) {
        console.log(e);
      }
    },    // Refunds: paid HoReCa order, delivered (or stock_out), and an ops role.
    canRefund(item) {
      return (
        this.isPaidHoreca(item) &&
        ["delivered", "stock_out"].includes(item.order_status) &&
        this.$store.state.authfack.user.roles.some((r) =>
          ["SuperAdmin", "SubAdmin", "AccountManagers"].includes(r.name)
        )
      );
    },
    openRefund(v) {
      this.selectedOrder = v;
      this.$bvModal.show("bv-refund");
    },
    refundVariant(status) {
      return status == "processed"
        ? "success"
        : status == "failed"
        ? "danger"
        : "warning";
    },
    refundLabel(status) {
      return status == "processed"
        ? "Refunded"
        : status == "failed"
        ? "Failed"
        : "Processing";
    },
    openPayment(v) {
      this.selectedOrder = v;
      this.$bvModal.show("show-payment");
    },
    reload() {
      this.getOrders();
      this.$bvModal.hide("bv-view-returns");
    },
    // A HORECA order is paid up-front on the ordered quantities, and the invoice
    // bills those same quantities. Editing the order after payment replaces every
    // line (the save does a delete-all + recreate), so the basket the partner was
    // charged for is lost and the invoice stops matching what was collected.
    // Shortfalls belong on the Mark As Shipped screen, which records the shipped
    // qty without touching what was ordered.
    isPaidHoreca(item) {
      return (
        item.order_type == "horeca" &&
        item.payment_status &&
        item.payment_status.status == "paid"
      );
    },
    setEdit(d) {
      this.selectedOrder = d;
      this.$bvModal.show("bv-add-order");
    },
    addOrder() {
      this.selectedOrder = {};
      this.$bvModal.show("bv-add-order");
    },
    addBrandKit() {
      this.$bvModal.show("bv-add-brand-kit");
    },
    editBrandKit() {
      this.$bvModal.show("bv-edit-brand-kit");
    },
    acceptOrder(v) {
      this.selectedOrder = v;
      this.$bvModal.show("bv-accept-order");
    },
    markAsShipped(v) {
      this.selectedOrder = v;
      this.$bvModal.show("bv-mark-as-shipped");
    },
    async markAsDelivered(v) {
      // Own outlets submit a GRN (qty_delivered is already recorded on the lines),
      // so ops opens the modal to review / adjust those numbers before confirming.
      // Non-own outlets have no GRN — mark delivered straight away, no modal, and
      // the backend fills qty_delivered from qty_shipped exactly as before.
      if (Number(v?.restaurant?.flags?.own_outlet) === 1) {
        this.selectedOrder = v;
        this.$bvModal.show("bv-mark-as-delivered");
        return;
      }
      try {
        let res = await axios.post(
          this.base_url + GravyPath.ORDERS.MARK_AS_DELIVERED,
          {
            order_id: v.id,
          }
        );
        if (res.data.status) {
          Swal.fire("success", "", "success");
          this.getOrders();
        } else {
          Swal.fire(res.data.message, "", "error");
        }
      } catch (e) {
        console.log(e);
        // A network/500 failure must not look like nothing happened, or ops
        // just clicks the delivered icon again.
        Swal.fire("Failed to mark as delivered", "", "error");
      }
    },
    escapeHtml(s) {
      return String(s ?? "").replace(
        /[&<>"']/g,
        (c) =>
          ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[
            c
          ])
      );
    },
    // Publishes the order to CW Suite as a stock indent. CW keys on the order's
    // ref_id, so a retry after a timeout returns the same indent, never a second one.
    async publishToCw(v) {
      const { isConfirmed } = await Swal.fire({
        title: "Publish to CW?",
        text: `Order ${v.ref_id} for ${v.restaurant?.name || ""} will be raised as a stock indent in CW. It can't be sent again after this.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Publish",
      });
      if (!isConfirmed) return;

      this.$set(v, "cw_publishing", true);
      try {
        let res = await axios.post(
          this.base_url + GravyPath.ORDERS.PUBLISH_TO_CW,
          { id: v.id }
        );
        if (res.data.status) {
          const d = res.data.data || {};
          const warnings = (d.warnings || []).length
            ? "<br><small>" +
              d.warnings.map((w) => this.escapeHtml(w.message || w)).join("<br>") +
              "</small>"
            : "";
          Swal.fire({
            title: "Published to CW",
            html: `Indent no: <b>${this.escapeHtml(d.document_no)}</b>${
              d.duplicate ? " (already existed in CW)" : ""
            }${warnings}`,
            icon: "success",
          });
        } else {
          const errors = (res.data.errors || [])
            .map(
              (e) =>
                `<li>${this.escapeHtml(e.item || (e.lineNo ? "Line " + e.lineNo : e.field || ""))}: ${this.escapeHtml(e.message || e.code)}</li>`
            )
            .join("");
          Swal.fire({
            title: "CW publish failed",
            html:
              this.escapeHtml(res.data.message) +
              (errors
                ? `<ul style="text-align:left;max-height:300px;overflow:auto">${errors}</ul>`
                : ""),
            icon: "error",
          });
        }
      } catch (e) {
        console.log(e);
        Swal.fire(
          "CW publish failed",
          e.response?.data?.message || e.message,
          "error"
        );
      } finally {
        this.$set(v, "cw_publishing", false);
        this.getOrders();
      }
    },
    async markAsPending(v) {
      try {
        let res = await axios.post(
          this.base_url + GravyPath.ORDERS.MARK_AS_PENDING,
          {
            id: v.id,
          }
        );
        if (res.data.status) {
          Swal.fire("success", "", "success");
          this.getOrders();
        } else {
          Swal.fire(res.data.message, "", "error");
        }
      } catch (e) {
        console.log(e);
      }
    },
    async generateInvoice(v) {
      try {
        let res = await axios.get(
          this.base_url + GravyPath.ORDERS.GRAVY_ORDER_INVOICE,
          {
            params: {
              id: v.id,
            },
          }
        );
        if (res.data.status) {
          this.downloadInvoiceFile(res.data.data);
        }
      } catch (e) {
        console.log(e);
      }
    },
    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    downloadInvoiceFile(file) {
      const link = document.createElement("a");
      link.href = this.cdn + "/" + file;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    openItems(v) {
      this.selectedOrder = v;
      this.$bvModal.show("bv-view-order");
    },
    getFormatedDate(v) {
      return moment(v).format("YYYY-MM-DD");
    },
    async deleteOrder(d) {
      try {
        let finalReason = "";

        if (
          this.$store.state.authfack.user.roles.filter(
            (f) => f.name == "SuperAdmin"
          ).length == 0
        ) {
          const { value: selectedReason, isDismissed } = await Swal.fire({
            title: "Please Select the Reason for Deletion",
            input: "select",
            inputOptions: {
              "RP Not Accepting Projections": "RP Not Accepting Projections",
              "Outlet Not Operational": "Outlet Not Operational",
              Deboarded: "Deboarded",
              "Have Enough Stock": "Have Enough Stock",
              "RP Giving Requirements": "RP Giving Requirements",
              Other: "Other",
            },
            inputPlaceholder: "Select a reason",
            showCancelButton: true,
            inputValidator: (value) => {
              if (!value) {
                return "You must select a reason!";
              }
            },
          });

          if (isDismissed) return;

          finalReason = selectedReason;

          if (selectedReason === "Other") {
            const { value: customReason, isDismissed: isOtherDismissed } =
              await Swal.fire({
                title: "Enter Your Reason",
                input: "textarea",
                inputPlaceholder: "Type your reason here...",
                showCancelButton: true,
                inputAttributes: {
                  "aria-label": "Reason",
                  style:
                    "height: 100px; border: 2px solid #3498db; border-radius: 4px; padding: 10px",
                },
                inputValidator: (value) => {
                  if (!value.trim()) {
                    return "Reason cannot be empty!";
                  }
                },
              });

            if (isOtherDismissed) return;

            finalReason = customReason;
          }
        }

        let response = await axios.delete(
          this.base_url + GravyPath.ORDERS.DELETE + "/" + d.id,
          {
            params: {
              delete_reason: finalReason,
              source: "pos",
            },
          }
        );

        if (response.data.status === true) {
          this.$bvToast.toast("Successfully Deleted", {
            title: "Gravy Deleted",
            variant: "success",
            solid: true,
          });
          this.getOrders();
        }
      } catch (error) {
        console.log(error);
      }
    },
    openReturns(v) {
      this.selectedOrder = v;
      this.$bvModal.show("bv-view-returns");
    },
    getRowClass(item, type) {
      if (!item || type !== "row") return "";
      if (item.source_res_id) return "transfer-row";
      if (item.order_type === "horeca") return "horeca-row";
      if ((item.created_by || "").trim() === "Dil-CRM")
        return "dil-crm-row";
      return "";
    },
  },
  mounted() {
    if (
      this.$store.state.authfack.user.roles.filter(
        (f) => f.name == "DeliveryExecutive"
      ).length > 0
    ) {
      this.order_type = "shipped";
    }
    this.$nextTick(() => {
      this.getOrders();
    });

    console.log(this.$store.state.authfack.user, "jj");
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body py-1" style="margin-bottom: 50px">
            <b-row align-v="end" class="mb-4">
              <b-col cols="12" md="auto" class="d-flex flex-wrap align-items-end">
                <!-- Add Order Button (Consolidated Logic) -->
                <b-button
                  v-if="
                    $store.state.authfack.user?.restaurant?.name == 'Chennai Skanda Restaurant' ||
                    $store.state.authfack.user.roles.some(f => f.name != 'RestaurantPartner' && f.name != 'DeliveryExecutive')
                  "
                  variant="primary"
                  class="mr-2 mb-2 mb-md-0"
                  @click="addOrder()"
                >
                  <i class="fas fa-plus mr-1"></i> Add Order
                </b-button>

                <!-- Brand Kit Actions -->
                <template v-if="$store.state.authfack.user.roles.some(f => f.name != 'RestaurantPartner' && f.name != 'DeliveryExecutive')">
                  <!-- <b-button
                    variant="primary"
                    class="mr-2 mb-2 mb-md-0"
                    @click="addBrandKit()"
                  >
                    Add Brand Kit
                  </b-button> -->
                  <b-button
                    variant="primary"
                    class="mb-2 mb-md-0"
                    @click="editBrandKit()"
                  >
                    Edit Brand
                  </b-button>
                </template>
              </b-col>

              <!-- LPG / HORECA filters -->
              <b-col cols="12" sm="auto" class="ml-md-auto mt-3 mt-md-0 d-flex flex-column justify-content-end">
                <b-form-checkbox v-model="lpgOnly" switch class="mb-1">
                  LPG orders only
                </b-form-checkbox>
                <b-form-checkbox v-model="horecaOnly" switch class="mb-1">
                  HORECA orders only
                </b-form-checkbox>
              </b-col>

              <!-- Search Bar -->
              <b-col cols="12" sm="8" md="4" lg="3" class="mt-3 mt-md-0">
                <label class="mb-1 font-weight-bold">Search</label>
                <b-form-input
                  v-model="search"
                  placeholder="Search orders..."
                  :debounce="300"
                ></b-form-input>
              </b-col>
            </b-row>
            <div class="row mb-2">
              <div class="col-md-4">
                <b-modal
                  id="bv-add-order"
                  size="xl"
                  dialog-class="order-modal-wide"
                  :title="
                    (Object.keys(selectedOrder).length > 0 ? 'Edit' : 'Add') +
                    ' Order'
                  "
                  hide-footer
                >
                  <add
                    @update="reload()"
                    :selected-order="selectedOrder"
                    :order_type="order_type"
                  ></add>
                </b-modal>
                <b-modal
                  id="bv-add-brand-kit"
                  size="xl"
                  title="Brand kit"
                  hide-footer
                >
                  <BrandKit @update="reload()"></BrandKit>
                </b-modal>
                <b-modal
                  id="bv-edit-brand-kit"
                  size="xl"
                  title="Edit Brand Kit"
                  hide-footer
                >
                  <EditBrandKit @update="reload()"></EditBrandKit>
                </b-modal>
                <b-modal
                  id="bv-accept-order"
                  size="xl"
                  :title="'Accept Order'"
                  hide-footer
                >
                  <accpet-orders
                    @update="reload()"
                    :selected-order="selectedOrder"
                  ></accpet-orders>
                </b-modal>
                <b-modal
                  id="bv-view-order"
                  size="xl"
                  :title="'View Order'"
                  hide-footer
                >
                  <View_items
                    @update="reload()"
                    :selected-order="selectedOrder"
                  ></View_items>
                </b-modal>
                <b-modal
                  id="bv-view-returns"
                  size="xl"
                  :title="'View Returns'"
                  hide-footer
                >
                  <View_returns
                    @update="reload()"
                    :selected-order="selectedOrder"
                  ></View_returns>
                </b-modal>
                <b-modal
                  id="show-payment"
                  size="xl"
                  :title="'Order #' + selectedOrder?.ref_id"
                >                  <Payments :order="selectedOrder"></Payments>
                </b-modal>
                <b-modal
                  id="bv-refund"
                  size="xl"
                  :title="'Refund · Order #' + selectedOrder?.ref_id"
                  hide-footer
                >
                  <Refund
                    :selected-order="selectedOrder"
                    @update="reload()"
                  ></Refund>
                </b-modal>
<b-modal
                  id="bv-mark-as-shipped"
                  size="xl"
                  :title="'Marks As Shipped Order'"
                  hide-footer
                >
                  <mark-as-shipped
                    @update="reload()"
                    :selected-order="selectedOrder"
                  ></mark-as-shipped>
                </b-modal>
                <b-modal
                  id="bv-mark-as-delivered"
                  size="xl"
                  :title="'Mark As Delivered Order'"
                  hide-footer
                >
                  <mark-as-delivered
                    @update="reload()"
                    :selected-order="selectedOrder"
                  ></mark-as-delivered>
                </b-modal>
              </div>
              <!-- Search -->
              <!--              <div class="col-sm-12 col-md-6">-->
              <!--                <div id="tickets-table_filter" class="dataTables_filter text-md-right">-->
              <!--                  <label class="d-inline-flex align-items-center mr-5">-->
              <!--                    Search:-->
              <!--                    <b-form-input v-model="filter" type="search" class="form-control form-control-sm ml-2"></b-form-input>-->
              <!--                    &lt;!&ndash; <b-form-input v-model="filter" type="search" class="form-control form-control-sm ml-2"></b-form-input> &ndash;&gt;-->
              <!--                  </label>-->
              <!--                </div>-->
              <!--              </div>-->

              <!-- End search -->
            </div>
            <div class="tab-container">
              <b-tabs
                content-class="overflow-x-auto"
                nav-wrapper-class="no-wrap-tabs"
              >
                <b-tab
                  title="Pending"
                  :active="
                    $store.state.authfack.user.roles.filter(
                      (f) => f.name == 'DeliveryExecutive'
                    ).length == 0
                  "
                  v-if="
                    $store.state.authfack.user.roles.filter(
                      (f) => f.name == 'DeliveryExecutive'
                    ).length == 0
                  "
                  @click="order_type = 'pending'"
                ></b-tab>
                <b-tab
                  title="Accepted"
                  v-if="
                    $store.state.authfack.user.roles.filter(
                      (f) =>
                        f.name != 'RestaurantPartner' &&
                        f.name != 'DeliveryExecutive'
                    ).length > 0
                  "
                  @click="order_type = 'accepted'"
                ></b-tab>
                <!-- <b-tab
                  title="Out Of Stock"
                  @click="order_type = 'stock_out'"
                  v-if="
                    $store.state.authfack.user.roles.filter(
                      (f) => f.name != 'RestaurantPartner'
                    ).length > 0
                  "
                ></b-tab> -->
                <b-tab
                  title="Shipped"
                  :active="
                    $store.state.authfack.user.roles.filter(
                      (f) => f.name == 'DeliveryExecutive'
                    ).length > 0
                  "
                  @click="order_type = 'shipped'"
                ></b-tab>
                <b-tab
                  title="Delivered"
                  v-if="
                    $store.state.authfack.user.roles.filter(
                      (f) => f.name != 'DeliveryExecutive'
                    ).length > 0
                  "
                  @click="order_type = 'delivered'"
                ></b-tab>
              </b-tabs>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                :key="orders.key"
                :items="orders.data"
                :fields="
                  fields.filter((f) => f.key != 'cw' || canPublishToCw).filter((f) =>
                    order_type == 'shipped'
                      ? f != 'delivered_at' && f != 'order_status'
                      : order_type == 'delivered'
                      ? f != 'order_status'
                      : order_type == 'pending'
                      ? f != 'delivered_at' &&
                        f != 'Payment' &&
                        f != 'shipped_at'
                      : order_type == 'accepted'
                      ? f != 'delivered_at' &&
                        f != 'Payment' &&
                        f != 'shipped_at'
                      : f
                  )
                "
                responsive="sm"
                :filter="filter"
                :current-page="currentPage"
                :tbody-tr-class="getRowClass"
              >
                <template v-slot:cell(payment)="row">
                  <!-- Store-to-store transfer: view only in POS — the stores handle it. -->
                  <template v-if="!row.item.source_res_id">
                    <i
                      class="fa fa-check-circle p-2"
                      aria-hidden="true"
                      style="color: green"
                      v-if="
                        row.item.payment_status &&
                        row.item.payment_status.status == 'paid'
                      "
                    >
                      Paid Online</i
                    >
                    <b-badge
                      v-if="row.item.refund"
                      :variant="refundVariant(row.item.refund.status)"
                      class="ml-1"
                      v-b-tooltip:hover
                      :title="'Razorpay ' + (row.item.refund.razorpay_refund_id || 'refund')"
                    >
                      Refund ₹{{ row.item.refund.refund_amount / 100 }} ·
                      {{ refundLabel(row.item.refund.status) }}
                    </b-badge>
                    <div style="display: flex; gap: 0px">
                      <div
                        v-if="
                          row.item.order_status != 'pending' &&
                          row.item.order_status != 'accepted'
                        "
                        @click="openPayment(row.item)"
                      >
                        <CardIcon />
                      </div>
                    </div>
                  </template>
                </template>
                <template v-slot:cell(ref_id)="row">
                  {{ row.item.ref_id }}
                  <b-row>
                    <b-col
                      ><b-badge
                        :variant="
                          row.item.order_type == 'dining'
                            ? 'primary'
                            : 'secondary'
                        "
                        >{{
                          capitalizeFirstLetter(row.item.order_type)
                        }}</b-badge
                      ></b-col
                    >
                    <b-col
                      ><b-badge
                        :variant="
                          row.item.order_type == 'credit' ? 'info' : 'success'
                        "
                        >{{
                          capitalizeFirstLetter(row.item.payment_mode)
                        }}</b-badge
                      ></b-col
                    >
                  </b-row>
                </template>
                <template v-slot:cell(images)="row">
                  <b-img
                    v-for="(im, i) in row.item.images"
                    :src="cdn + '/' + im.img_url"
                    :key="i"
                    size="20"
                  ></b-img>
                </template>
                <template v-slot:cell(restaurant)="row">
                  <template v-if="row.item.source_res_id">
                    <p style="margin-bottom: 0px">
                      {{ row.item.source_restaurant?.name || "Store" }} →
                      {{ row.item.restaurant?.name }}
                    </p>
                    <b-badge variant="info">Store transfer</b-badge>
                  </template>
                  <p v-else style="margin-bottom: 0px">
                    {{ row.item.restaurant?.name }}
                  </p>
                </template>
                <template v-slot:cell(city)="row">
                  <p style="margin-bottom: 0px">
                    {{ row.item.restaurant?.city }}
                  </p>
                </template>
                <template v-slot:cell(view_items)="row">
                  <!-- <b-button class="text-center"
                    ><i class="fa fa-list-alt"></i
                  ></b-button> -->
                  <div style="display: flex; gap: 0px">
                    <div @click="openItems(row.item)">
                      <ListIcon />
                    </div>
                  </div>
                </template>
                <template v-slot:cell(order_status)="row">
                  <!-- Store-to-store transfer: view only in POS — the stores handle it. -->
                  <template v-if="!row.item.source_res_id">
                    <div style="display: flex; gap: 0px">
                      <div
                        v-if="
                          $store.state.authfack.user.roles.filter(
                            (f) => f.name != 'RestaurantPartner'
                          ).length > 0 &&
                          row.item.order_status == 'pending' &&
                          ((row.item.created_by || '').trim() !=
                            'Dil Foods Model' ||
                            $store.state.authfack.user.roles.filter(
                              (f) => f.name == 'SuperAdmin'
                            ).length > 0)
                        "
                        @click="acceptOrder(row.item)"
                      >
                        <AcceptIcon />
                      </div>
                      <div
                        @click="markAsPending(row.item)"
                        v-if="
                          $store.state.authfack.user.roles.filter(
                            (f) => f.name != 'RestaurantPartner'
                          ).length > 0 && row.item.order_status == 'test'
                        "
                      >
                        <PendingIcon />
                      </div>
                      <div
                        v-if="
                          $store.state.authfack.user.roles.filter(
                            (f) => f.name != 'RestaurantPartner'
                          ).length > 0 && row.item.order_status == 'accepted'
                        "
                        @click="markAsShipped(row.item)"
                      >
                        <ShippedIcon />
                      </div>
                    </div>
                    <!-- <p v-else>{{ row.item.order_status }}</p> -->
                  </template>
                </template>
                <template v-slot:cell(cw)="row">
                  <div v-if="row.item.cw_document_no" style="white-space: nowrap">
                    <b-badge
                      variant="success"
                      v-b-tooltip:hover
                      :title="
                        'Published ' +
                        getFormatedDate(row.item.cw_published_at) +
                        (row.item.cw_published_by
                          ? ' by ' + row.item.cw_published_by
                          : '')
                      "
                      >CW #{{ row.item.cw_document_no }}</b-badge
                    >
                  </div>
                  <template
                    v-else-if="
                      canPublishToCw &&
                      (row.item.order_status == 'pending' ||
                        row.item.order_status == 'accepted') &&
                      !row.item.source_res_id
                    "
                  >
                    <b-button
                      size="sm"
                      variant="outline-primary"
                      style="white-space: nowrap"
                      :disabled="row.item.cw_publishing"
                      @click="publishToCw(row.item)"
                    >
                      <b-spinner v-if="row.item.cw_publishing" small></b-spinner>
                      <span v-else>Publish to CW</span>
                    </b-button>
                    <div
                      v-if="row.item.cw_publish_error"
                      class="text-danger small mt-1"
                      style="max-width: 220px"
                      v-b-tooltip:hover
                      :title="row.item.cw_publish_error"
                    >
                      Last attempt failed
                    </div>
                  </template>
                </template>
                <template v-slot:cell(actions)="row">
                  <!-- Store-to-store transfer: view only in POS — the stores handle it. -->
                  <template v-if="!row.item.source_res_id">
                    <!-- <i class="fa fa-pen"></i> -->
                    <div style="display: flex; gap: 0px">
                      <div
                        @click="setEdit(row.item)"
                        v-if="
                          (!isPaidHoreca(row.item) || isSuperAdmin) &&
                          ((row.item.order_status == 'pending' &&
                            $store.state.authfack.user.roles.filter(
                              (f) => f.name == 'SuperAdmin'
                            ).length > 0) ||
                            (row.item.order_status == 'accepted' &&
                              $store.state.authfack.user.roles.filter(
                                (f) => f.name != 'RestaurantPartner'
                              ).length > 0))
                        "
                      >
                        <EditIcon />
                      </div>
                      <div style="display: flex; gap: 0px">
                        <div
                          v-if="
                            (row.item.order_status == 'delivered' &&
                              $store.state.authfack.user.roles.filter(
                                (f) => f.name == 'SuperAdmin'
                              ).length > 0) ||
                            (row.item.order_status == 'delivered' &&
                              $store.state.authfack.user.roles.filter(
                                (f) => f.name != 'RestaurantPartner'
                              ).length > 0)
                          "
                        >
                          <p
                            style="cursor: pointer; font-size: 18px"
                            @click="openReturns(row.item)"
                            v-b-tooltip:hover
                            title="Add Returns"
                            class="secondary"
                          >
                            📦↩️
                          </p>
                        </div>
                      </div>
                      <div v-if="canRefund(row.item)">
                        <p
                          style="cursor: pointer; font-size: 18px"
                          @click="openRefund(row.item)"
                          v-b-tooltip:hover
                          :title="row.item.refund ? 'View refund' : 'Refund short-delivered items'"
                          class="secondary"
                        >
                          💸
                        </p>
                      </div>
  <div
                        @click="deleteOrder(row.item)"
                        v-if="
                          (!isPaidHoreca(row.item) || isSuperAdmin) &&
                          $store.state.authfack.user.roles.filter(
                            (f) => f.name != 'RestaurantPartner'
                          ).length > 0 &&
                          row.item.order_status != 'shipped' &&
                          row.item.order_status != 'delivered' &&
                          (row.item.created_by != 'Dil-CRM' ||
                            $store.state.authfack.user.roles.some(
                              (f) => f.name == 'SuperAdmin'
                            ) ||
                            $store.state.authfack.user.permissions
                              .map((p) => p.name)
                              .includes('DeleteSystemOrder'))
                        "
                      >
                        <DeleteIcon />
                      </div>
                      <!-- Own outlets must submit their GRN first, so nothing is
                           delivered against quantities nobody counted. The icon is
                           hidden, not disabled, and the "No GRN" chip below says why.
                           stock_out is exempt: a GRN can only be raised while the order
                           is shipped, so those would otherwise never be deliverable. -->
                      <div
                        v-if="
                          $store.state.authfack.user.roles.filter(
                            (f) => f.name != 'RestaurantPartner'
                          ).length > 0 &&
                          (row.item.order_status == 'shipped' ||
                            row.item.order_status == 'stock_out') &&
                          (Number(row.item.restaurant?.flags?.own_outlet) !== 1 ||
                            row.item.order_status == 'stock_out' ||
                            row.item.grn_submitted_at)
                        "
                        @click="markAsDelivered(row.item)"
                      >
                        <DeliveredIcon />
                      </div>
                      <!-- Sits beside the delivered icon: whether the outlet has already
                           counted what arrived, so the quantities behind that icon can be
                           trusted without opening the modal. Own outlets only — nobody
                           else submits a GRN. -->
                      <div
                        class="d-flex align-items-center"
                        v-if="
                          $store.state.authfack.user.roles.filter(
                            (f) => f.name != 'RestaurantPartner'
                          ).length > 0 &&
                          (row.item.order_status == 'shipped' ||
                            row.item.order_status == 'stock_out') &&
                          Number(row.item.restaurant?.flags?.own_outlet) === 1
                        "
                      >
                        <b-badge
                          v-if="row.item.grn_submitted_at"
                          variant="success"
                          v-b-tooltip.hover
                          :title="
                            'GRN submitted on ' +
                            getFormatedDate(row.item.grn_submitted_at)
                          "
                          >GRN ✓</b-badge
                        >
                        <b-badge
                          v-else
                          variant="warning"
                          v-b-tooltip.hover
                          title="The outlet has not counted this order yet, so it cannot be marked as delivered"
                          >No GRN done</b-badge
                        >
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <b-badge
                      v-if="row.item.order_status == 'shipped' && row.item.grn_submitted_at"
                      variant="warning"
                      v-b-tooltip.hover
                      title="The receiving store's GRN did not match what was sent; waiting for the sending store to approve"
                      >Awaiting Approval</b-badge
                    >
                    <b-badge v-else variant="light">Store transfer</b-badge>
                  </template>
                </template>
                <template v-slot:cell(created_at)="row">
                  {{ getFormatedDate(row.item.created_at) }}
                </template>
                <template v-slot:cell(invoice)="row">
                  <!-- Store-to-store transfer: view only in POS — the stores handle it. -->
                  <template v-if="!row.item.source_res_id">
                    <!-- <b-button
                      class="mb-2"
                      @click="downloadInvoiceFile(row.item.invoice_url)"
                      variant="success"
                      v-if="row.item.invoice_url != ''"
                      v-b-tooltip:hover
                      title="Generate"
                    >
                      <i class="fa fa-download"></i>
                    </b-button> -->
                    <div
                      style="display: flex; gap: 0px"
                      v-if="
                        $store.state.authfack.user.roles.filter(
                          (f) => f.name != 'RestaurantPartner'
                        ).length > 0 ||
                        // (row.item.order_status == 'delivered' ||
                        //   row.item.order_status == 'shipped' ||
                        //   row.item.order_status == 'stock_out')
                        ($store.state.authfack.user.roles.filter(
                          (f) => f.name == 'RestaurantPartner'
                        ).length > 0 &&
                          (row.item.order_status == 'delivered' ||
                            row.item.order_status == 'stock_out'))
                      "
                    >
                      <div
                        @click="downloadInvoiceFile(row.item.invoice_url)"
                        variant="success"
                        v-if="row.item.invoice_url !== null"
                      >
                        <b-button
                          v-if="row.item.order_status == 'accepted'"
                          variant="success"
                          size="sm"
                          class="text-nowrap mt-2"
                          >Download Indent</b-button
                        >
                        <DownloadIcon v-else />
                      </div>
                      <template
                        v-if="
                          $store.state.authfack.user.roles.filter(
                            (f) => f.name != 'RestaurantPartner'
                          ).length > 0
                        "
                      >
                        <div @click="generateInvoice(row.item)">
                          <RegenerateIcon
                            :title="
                              row.item.invoice_url != null
                                ? 'Regenerate'
                                : 'Generate'
                            "
                          />
                        </div>
                      </template>
                    </div>
                    <!-- <b-button
                      v-b-tooltip:hover
                      :title="
                        row.item.invoice_url != '' ? 'Regenerate' : 'Generate'
                      "
                    >
                      <template v-if="row.item.invoice_url != ''">
                        <i class="fa fa-recycle"></i>
                      </template>
                      <template v-else>
                        <i class="fa fa-down"></i>
                      </template>
                    </b-button> -->
                  </template>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul
                    class="pagination pagination-rounded"
                    style="margin-top: 0px !important"
                  >
                    <!-- pagination -->
                    <b-pagination
                      :key="orders.key"
                      v-model="currentPage"
                      :total-rows="orders.total"
                      :per-page="orders.per_page"
                      class="dataTables_paginate"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
@media (max-width: 768px) {
}
@media (min-width: 1400px) {
  .order-modal-wide {
    max-width: 1300px;
  }
}
.tab-container {
  max-width: 100%;
  overflow-x: auto;
}
.no-wrap-tabs {
  white-space: nowrap;
  width: max-content;
}
.dataTables_paginate {
  display: flex !important;
}

/* HORECA row styling */
.horeca-row {
  background-color: #99ff99 !important;
}

.horeca-row:hover {
  background-color: #4dff4d !important;
}

/* Optional: Add a subtle left border for extra distinction */
.horeca-row td:first-child {
  border-left: 4px solid #28a745;
}

/* Dil-CRM auto-generated order row styling */
.dil-crm-row {
  background-color: #cce5ff !important;
}

.dil-crm-row:hover {
  background-color: #9ecaff !important;
}

.dil-crm-row td:first-child {
  border-left: 4px solid #007bff;
}

/* Store-to-store transfer row — view only in POS */
.transfer-row {
  background-color: #f3e8ff !important;
}

.transfer-row td:first-child {
  border-left: 4px solid #7c3aed;
}
</style>
